
import PropTypes from 'prop-types';

import { CartContext } from '../../../providers/CartContext';
import { formatPrice } from "../../../lib/utils";

// this is only used for cart items with selected addons and options
function TrackOrderItem(props) {
  const { item, quantity, priceUnit, price, itemName, maxValue, id, setValue } = props;

  const { comboProductPriceForSize } = React.useContext(CartContext);

  const _itemOptions = (item) => {
    if (!item.selectedOptions || item.selectedOptions.length === 0) return <div className="item-options selected-options"></div>
    return (
      <div className="item-options  selected-options mt-1">
        {item.selectedOptions.map((opt) => {
          return (
            <div className="text-gray mb-0 space-between" key={"option_" + opt.id}>
              <span>{opt.group_name}:</span>
              <span>{opt.name}</span>
              <span>{formatPrice(opt.price * quantity)}</span>
            </div>
          )
        })}

      </div>
    )
  }

  const addonNameQuantity = (addon) => {
    if (addon.quantity > 1) {
      return <span>{addon.name} ({addon.quantity})</span>
    }
    return <span>{addon.name}</span>
  }

  const _itemAddons = (item) => {
    if (!item.selectedAddons || item.selectedAddons.length === 0) return <div className="item-options selected-addons"></div>
    return (
      <div className="item-options selected-addons">
        {item.selectedAddons.map((opt) => {
          return (
            <div className="text-gray mb-0 space-between" key={"option_" + opt.id}>
              {addonNameQuantity(opt)} <span>{formatPrice(opt.price * quantity)}</span>
            </div>
          )
        })}

      </div>
    )
  }

  const _itemCombos = (product) => {
    if (!product || product.type !== 'Combo') {
      return <></>
    }

    let chosenSize = product.chosenSize || product.size

    return (
      <div className="item-options selected-addons">
        {product.Combos && product.Combos.map((combo, index) => {

          return (
            <div className="text-gray mb-0 space-between" key={`combo_${index}`}>
              <span>{combo.selectedItem.name} </span> <span>{
              formatPrice(comboProductPriceForSize(combo.selectedItem, chosenSize, combo.multiplier))}</span>
            </div>
          )
        }

        )}
      </div>
    )
  }

  const _itemSize = (product) => {
    if (product.chosenSize && product.chosenSize !== '') {
      return (
        <div>
          <div className="text-gray mb-0 space-between" >
            <span>{product.chosenSize}</span>
          </div>
        </div>
      )
    }
    return <></>
  }

  //console.log("item", item)

  return (
    <div className="mt-1 osahan-cart-item">
     <span className="  mb-0 float-right ml-2 checkoutitem-price">{formatPrice(price * quantity)}</span>
      <span className="count-number float-right">
        <input className="count-number-input" type="text" value={quantity} readOnly />
      </span>
      <div className="media">
        <div className="mr-2"><i className="icofont-ui-press text-danger food-item" /></div>
        <div className="media-body">
          <p className="mt-1 mb-0 text-black">{itemName}</p>
        </div>
      </div>

      {/* combos */}
      {_itemCombos(props.item)}

      {/* options */}
      {_itemOptions(props.item)}


      {/* addons */}
      {_itemAddons(props.item)}

    </div>
  )
}

TrackOrderItem.propTypes = {
  title: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  icoIcon: PropTypes.string.isRequired,
  iconclass: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired
};

TrackOrderItem.defaultProps = {
  title: '',
  price: 0,
  icoIcon: '',
  iconclass: '',
  item: {},
}

export default TrackOrderItem;